import React, { Suspense } from 'react'
import { TitleController, Loading } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import { ContactInfoView } from './ContactInfoView'
import { ContactInfoDataLoader } from './ContactInfoDataLoader'
import { ContactInfoErrorHandler } from './ContactInfoErrorHandler'

export const ContactInfo = () => {
  const { t } = useTranslation(['contact'])

  return (
    <TitleController title={t('contact:contactInformation')}>
      <Suspense fallback={<Loading variant="details" />}>
        <ContactInfoErrorHandler>
          <ContactInfoDataLoader>
            {({ contacts }) => <ContactInfoView contacts={contacts} />}
          </ContactInfoDataLoader>
        </ContactInfoErrorHandler>
      </Suspense>
    </TitleController>
  )
}
